import React from 'react'

import { StatusBar, StatusClearAll, StatusWrapper } from './Status.styles'
import StatusItem from './StatusItem.container'
// import StatusSortItem from './StatusSortItem.container'
import StatusSearchItem from './StatusSearchItem.container'

const StatusComponent = ({ api, events, i18n, sort, filters, customFilter, search, handleRemoveFilter, handleRemoveSearch, analytics }) => {
  let searchClass = ''

  if (customFilter || filters.length > 0) {
    searchClass = 'first-item'
  }

  return (
    <StatusBar data-testid='status-bar'>
      <StatusWrapper>
        {search && search !== '' &&
        <StatusSearchItem 
          handleRemoveSearch={handleRemoveSearch} 
          search={search} 
          className={searchClass} 
          analytics={analytics} 
        />
        }

        {customFilter &&
        <StatusItem 
          api={api} 
          handleRemoveFilter={events.handleClearAllClick} 
          key={'filter-item-custom'} 
          type={'customfilter'} 
          customFilter={customFilter} 
          column=''
          analytics={analytics}
          />
        }

        {!customFilter &&
        filters.map((filterItem, i) => {
          return (
            <StatusItem 
              api={api} 
              handleRemoveFilter={handleRemoveFilter} 
              key={'filter-item-' + i} 
              type={'filter'}
              analytics={analytics} 
              {...filterItem} />
          )
        })
        }
      </StatusWrapper>
      <StatusClearAll onClick={events.handleClearAllClick}>{i18n.clearAll}</StatusClearAll>
    </StatusBar>
  )
}

export default StatusComponent
